
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import "./App.css";

import Login from "./pages/Login";
import Home from "./pages/Home";
import ConfigPage from "./pages/ConfigPage";
import AuthCallbackPage from "./components/AuthCallbackPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Login */}
        <Route
          path="/login"
          element={<Login />}
        />

        {/* SSO Callback - keep for future SSO integration */}
        <Route
          path="/auth/callback"
          element={<AuthCallbackPage />}
        />

        {/* Home */}
        <Route
          path="/home"
          element={<Home />}
        />

        {/* IdP configuration */}
        <Route
          path="/config"
          element={<ConfigPage />}
        />

        {/* Default */}
        <Route
          path="/"
          element={<Navigate to="/login" replace />}
        />

        {/* Invalid URL */}
        <Route
          path="*"
          element={<Navigate to="/login" replace />}
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;

